import { colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';

export const FileName = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  flex: 2;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const Wrapper = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  flex: 1;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  padding: 0 4px;
`;

export const OwnerWrapper = styled(Wrapper)``;

export const FileTypeWrapper = styled(Wrapper)`
  flex: inherit;
  padding: 0 8px 0 4px;
`;

export const HierarchyNameWrapper = styled(Wrapper)`
  flex: 2;
  min-width: 0;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const IconWrapper = styled(Wrapper)`
  flex: none;
  height: 100%;
  margin-right: 8px;
`;

export const ActionsWrapper = styled.div`
  flex: none;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
`;

export const DownloadFileNote = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 12px;
  margin-left: 8px;
`;

interface IMalformedRowDiv {
  isMalformed?: boolean;
}

export const Container = styled.div<IMalformedRowDiv>`
  display: flex;
  width: 100%;
  height: 32px;
  padding: 8px 8px 8px 16px;
  background-color: ${colors.white};
  box-shadow: 0px 3px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -2px rgba(0, 0, 0, 0.1);
  border-radius: 1px;
  box-sizing: border-box;
  align-items: center;
  position: relative;
  cursor: ${({ isMalformed }) => (isMalformed ? 'pointer' : 'auto')};

  &:hover {
    background-color: ${colors.white};
  }

  ${Wrapper} {
    color: ${colors.grey500};
  }

  ${({ isMalformed }) =>
    isMalformed
      ? css`
          ${FileName} + ${Wrapper} {
            color: ${colors.amber600};
          }
        `
      : ''};
`;
